export default __webpack_public_path__ + "static/ue-logo-4-6d4331791c73788080a4757a1c0f892f.svg";